var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M1.955.705A1 1 0 0 0 .537.713L.713.537a1.007 1.007 0 0 0-.008 1.418L3.75 5 .705 8.045a1 1 0 0 0 .008 1.418l-.176-.176a1.007 1.007 0 0 0 1.418.008L5 6.25l3.045 3.045c.39.39 1.02.39 1.418-.008l-.176.176a1.007 1.007 0 0 0 .008-1.418L6.25 5l3.045-3.045A1 1 0 0 0 9.287.537l.176.176A1.007 1.007 0 0 0 8.045.705L5 3.75z"
  })));
};
export default SvgDelete;